import { searchChatByPhone } from "../chat/chatListModel";
import { fetchChatMessagesPage } from "../chat/chatMessagesModel";

// Composes two existing chat models to answer a narrow question specific to
// this drawer's "Add Part" photo picker: does this customer's WATI chat have
// any image messages we can offer as a source. Needed because this drawer
// isn't opened from within an already-loaded chat (unlike ChatPanelMessages'
// own onImageMessagesChange), so there's no live chat/messages state to
// piggyback on.
export function fetchCustomerChatImages(phone, userId) {
  const normalized = (phone || "").replace(/\D/g, "");
  if (!normalized) return Promise.resolve([]);
  return searchChatByPhone(userId, normalized)
    .then(({ list, success }) => {
      if (!success) return [];
      const hit = list.find(item => (item.whatsappId || "").replace(/\D/g, "") === normalized);
      if (!hit) return [];
      const conversationId = hit.ticket?.conversationId || hit.id;
      return fetchChatMessagesPage({ chatId: conversationId, lastMessageId: null, userId })
        .then(raw => raw.filter(m => m.eventType === "message" && (m.type || "").toLowerCase() === "image"));
    })
    .catch(() => []);
}
